import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from 'services';

export function catalogRedirectionGuard(currentRoute?: ActivatedRouteSnapshot): UrlTree {
    const userService = inject(UserService);
    const router = inject(Router);

    const brandId = currentRoute.params.brandId;
    const catalogId = currentRoute.params.id;

    if (userService.isRetailer()) {
        const catalogUrl = `/r/brand/${brandId}/reorder/catalogs/${catalogId}`;
        return router.parseUrl(catalogUrl);
    } else {
        const catalogUrl = `/data-manager/catalogs/${catalogId}?brandId=${brandId}`;
        return router.parseUrl(catalogUrl);
    }
}
